__turbopack_context__.v({
  "container": "X9vkdq_container",
  "thumb": "X9vkdq_thumb",
});
